import type Store from '@ember-data/store';
import { query } from '@warp-drive/utilities/json-api';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type SessionService from 'bcl/services/session';

export default class AuthRoute extends Route {
  @service declare router: RouterService;
  @service declare session: SessionService;
  @service declare store: Store;

  async beforeModel() {
    await this.session.requireAuthentication();
  }
  async model() {
    await Promise.all([
      this.store.request(query('item', undefined, { reload: true })),
      this.store.request(query('supplier', undefined, { reload: true })),
      this.store.request(query('location', undefined, { reload: true })),
      this.store.request(
        query(
          'order',
          {
            'filter[recent]': true,
          },
          { reload: true }
        )
      ),
      this.store.request(
        query(
          'stocktaking',
          {
            'filter[recent]': true,
          },
          { reload: true }
        )
      ),
      this.store.request(query('product-group', undefined, { reload: true })),
    ]);
  }
}
